import styled from '@emotion/styled';
import { simbaStyled } from '@naf-simba/theme';
import { Button } from '@naf-simba/elements-buttons';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';

export const ProfileMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 1rem;

  .naf-ButtonLabel {
    font-size: 1rem;
  }
`;

export const UserButton = simbaStyled<typeof Button, Record<string, never>>(Button)(() => ({
  '&&': {
    backgroundColor: 'transparent',
    color: nafColor.signature.black,
    height: '44px',
    minHeight: 'auto',
    padding: `0 ${spacing.space8}`,

    '& .naf-ButtonLabel': {
      fontSize: '1rem',
    },

    '&:hover': {
      backgroundColor: nafColor.signature.yellow40,
      color: nafColor.signature.black,
      textDecoration: 'none',
    },
  },
}));
